import { render, staticRenderFns } from "./AddOrUpdateLabModal.vue?vue&type=template&id=be08e10e&"
import script from "./AddOrUpdateLabModal.vue?vue&type=script&lang=js&"
export * from "./AddOrUpdateLabModal.vue?vue&type=script&lang=js&"
import style0 from "./AddOrUpdateLabModal.vue?vue&type=style&index=0&id=be08e10e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports